import { graphql } from '../../../gql';

export const MY_RECEIVED_VOUCHES_QUERY = graphql(`
  query myReceivedVouches {
    myReceivedVouches { vouchId sharerUsername boost windowEndsAt }
  }
`);
